import { get } from '@intigral/utils/lib/browser-storage/localStorage';
import { STORE_NAME } from '@intigral/constant';
import cn from 'classnames';
import { Channel, ChannelBox } from 'planby';
import { useContext, useEffect, useMemo, useRef } from 'react';
import { useInView } from 'react-intersection-observer';
import { FontIcon, ImageContainer } from '@intigral/shared';
import styles from './tvguide.module.sass';
import { EpgContainerRefContext } from './EPG';

interface ChannelItemProps {
    channel: Channel;
    selectedChannel: string | null;
    isSelected?: boolean;
    onChannelSelect?: any;
    favorite?: boolean;
    rewindDuration?: string;
}

export const ChannelItem = ({
    channel,
    selectedChannel,
    isSelected,
    onChannelSelect,
    favorite,
    rewindDuration,
}: ChannelItemProps) => {
    const { position, logo, locked, isLockedEpg } = channel;
    const epgContainerRef = useContext(EpgContainerRefContext);

    // the EPG scroller, so rootMargin pre-renders channels above/below what's visible in it
    const { ref: inViewRef, inView } = useInView({
        rootMargin: '600px 0px',
        root: epgContainerRef?.current ?? null,
    });

    // TODO: instead of passing container ref through context maybe scrollLeft() can be used to scroll the element
    // itself
    useEffect(() => {
        if (selectedChannel === channel.uuid && epgContainerRef?.current) {
            epgContainerRef.current.scrollTo({ top: position.top, behavior: 'smooth' });
        }
    }, [selectedChannel, epgContainerRef, channel, position.top]);

    return (
        <ChannelBox
            ref={(el) => {
                inViewRef(el);
            }}
            {...position}
            className={cn(styles.channel, { [styles.selected]: isSelected })}
            onClick={() => {
                if (!isSelected) {
                    onChannelSelect(channel);
                }
            }}
        >
            {inView ? (
                <>
                    <div className={styles.tops}>
                        <span className={styles.chIndex}>{channel?.channelNumber}</span>
                        {favorite && (
                            <span className={styles.favorite}>
                                <FontIcon name="heart-filled" size="x-small" md="x-small" color="orange" />
                            </span>
                        )}
                    </div>
                    {(locked || isLockedEpg) && (
                        <span className={styles.lock}>
                            <FontIcon name="lock-filled" />
                        </span>
                    )}
                    <div className={styles.chlogo}>
                        <div>
                            <ImageContainer src={logo} ratio={1.9} alt="" />
                        </div>
                    </div>
                    {rewindDuration && <div className={styles.label}>{rewindDuration}</div>}
                </>
            ) : null}
        </ChannelBox>
    );
};
